import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import {
  CreateUpdateExamWithTestsDto,
  CreateUpdateExternalReferralDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { Selector } from '../Selects/Selector';
import { EmploymentCandidateSelector } from '../Selects/EmploymentCandidateSelector';

interface EmployeeFormProps {
  externalReferral: CreateUpdateExternalReferralDto;
  textOrEmpty: (text: string | null | undefined) => string;
  propertyChangeExam: (obj: Partial<CreateUpdateExamWithTestsDto>) => void;
  changeExternalReferral: (jobPositionId: string, fieldName: string) => void;
  putCompanyName: () => void;
  putCompanyAddress: () => void;
  spdCore: {
    jobPositions: {
      getAllForSelector: (
        text: string,
      ) => Promise<{ label: string; value: string }[]>;
    };
  };
}

const EmployeeForm: React.FC<EmployeeFormProps> = ({
  externalReferral,
  textOrEmpty,
  propertyChangeExam,
  changeExternalReferral,
  putCompanyName,
  putCompanyAddress,
  spdCore,
}) => {
  return (
    <>
      <Card.Subtitle className="mb-4 mt-4">Pracodawca</Card.Subtitle>
      <FormRow controlId="employment_candidate" label="Pracownik/Kandydat">
        <EmploymentCandidateSelector
          value={externalReferral?.examWithTests?.employmentCandidate}
          onChange={value => propertyChangeExam({ employmentCandidate: value })}
        />
      </FormRow>
      {externalReferral?.examWithTests?.employmentCandidate === false && (
        <FormRow controlId="employeePeriod" label="Okres zatrudnienia">
          <Form.Control
            as="textarea"
            rows={2}
            value={textOrEmpty(externalReferral?.examWithTests?.employeePeriod)}
            onChange={e =>
              propertyChangeExam({ employeePeriod: e.target.value })
            }
          />
        </FormRow>
      )}
      <FormRow controlId="employerName" label="Nazwa pracodawcy">
        <div className="d-flex flex-column">
          <Button
            variant="outline-secondary"
            onClick={putCompanyName}
            className="mt-2 align-self-start"
          >
            Wstaw nazwę swojej firmy
          </Button>
          <Form.Control
            as="textarea"
            rows={3}
            value={textOrEmpty(externalReferral?.examWithTests?.employerName)}
            onChange={e => propertyChangeExam({ employerName: e.target.value })}
          />
        </div>
      </FormRow>
      <FormRow controlId="employerAddress" label="Adres pracodawcy">
        <div className="d-flex flex-column">
          <Button
            variant="outline-secondary"
            onClick={putCompanyAddress}
            className="mt-2 align-self-start"
          >
            Wstaw adres swojej firmy
          </Button>
          <Form.Control
            as="textarea"
            rows={3}
            value={textOrEmpty(
              externalReferral?.examWithTests?.employerAddress,
            )}
            onChange={e =>
              propertyChangeExam({ employerAddress: e.target.value })
            }
          />
        </div>
      </FormRow>
      <FormRow
        controlId="jobPosition"
        label="Predefiniowane stanowisko i czynniki szkodliwe"
      >
        <Selector
          onChange={chosen =>
            changeExternalReferral(chosen.value, 'jobPosition')
          }
          provider={spdCore.jobPositions.getAllForSelector}
        />
      </FormRow>
      <FormRow controlId="employmentPosition" label="Stanowisko">
        <Form.Control
          as="textarea"
          rows={3}
          value={textOrEmpty(
            externalReferral?.examWithTests?.employmentPosition,
          )}
          onChange={e =>
            propertyChangeExam({ employmentPosition: e.target.value })
          }
        />
      </FormRow>
    </>
  );
};

export default EmployeeForm;
